<template>
    <div>
        <card-header title="Edit Component" icon="fa-pencil"/>

        <card-body>
            <component-form :component="component"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteComponent"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Component?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!component.type || !component.title"
                    ><i class="fas fa-check mr-2"></i>Save Component
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import ComponentForm from "@/cards/components/ComponentForm";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";

    import {client as http} from '../../http_client';

    export default {
        components: {NavigationListItem, CardList, ComponentForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                component: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadComponent: function() {
                this.$emit('loading', true);
                http.get('components/' + this.props.componentId, {force: true}).then(response => {
                    this.component = response.data;
                    delete this.component.content;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('components/' + this.props.componentId, this.component, {force: true}).then(response => {
                    this.$reloadCard('components');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteComponent() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('components/' + this.props.componentId).then(response => {
                        this.$reloadCard('components');
                        this.$openCard('components', {}, null);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.componentId': function() {
                this.dirty = null;
                this.loadComponent();
            },
            'component': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this component? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadComponent();
        }
    };
</script>
